import React from "react"
import { Transition } from "react-transition-group"

const defaultStyle = {
  opacity: 0,
}

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
}

export function FadeInTransition({ duration, children }) {
  return (
    <Transition in timeout={duration} mountOnEnter appear>
      {state =>
        children({ defaultStyle, transitionStyles: transitionStyles[state] })
      }
    </Transition>
  )
}
